import { Component, Input, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs';
import { HubRecordEditorBase } from '../../../_hub_record_editor_base';
import {
    CustomOutcomeParentCustomOutcomeModel,
    OutcomeParentOutcomeModel,
    ProjectOutcomeModel
} from '../../../../../../hub_schema/hubTypes';
import { LinkStrategyOutcomesDialogComponent } from './link-strategy-outcomes-dialog/link-strategy-outcomes-dialog.component';

@Component({
    selector: 'app-linked-strategy-outcomes-edit-panel',
    templateUrl: './linked-strategy-outcomes-edit-panel.component.html',
    styleUrl: './linked-strategy-outcomes-edit-panel.component.scss',
    standalone: false
})
export class LinkedStrategyOutcomesEditPanelComponent extends HubRecordEditorBase {
    private dialogService: MatDialog = inject(MatDialog);

    @Input()
    public projectOutcome: ProjectOutcomeModel;

    public get isTncGoalsOutcome(): boolean {
        return !!this.projectOutcome.outcome;
    }

    public get parentOutcomes(): OutcomeParentOutcomeModel[] {
        return this.projectOutcome.outcome?.parentOutcomes ?? [];
    }

    public get parentCustomOutcomes(): CustomOutcomeParentCustomOutcomeModel[] {
        return this.projectOutcome.customOutcome?.parentCustomOutcomes ?? [];
    }

    public get parentCount(): number {
        return this.isTncGoalsOutcome ? this.parentOutcomes.length : this.parentCustomOutcomes.length;
    }

    private markDirty(): void {
        this.projectEditForm!.controls.projectOutcomes.markAsDirty();
    }

    public openLinkStrategyOutcomesDialog(): void {
        const dialogRef = this.dialogService.open(LinkStrategyOutcomesDialogComponent, {
            width: '90vw',
            height: '90vh',
            maxWidth: 'none',
            data: {
                projectOutcome: this.projectOutcome
            }
        });

        dialogRef.afterClosed().pipe(take(1)).subscribe(() => {
            if (this.parentCount > 0) {
                this.markDirty();
            }
        });
    }

    public unlinkParentOutcome(parentOutcome: OutcomeParentOutcomeModel): void {
        const parents = this.projectOutcome.outcome!.parentOutcomes!;
        const index = parents.indexOf(parentOutcome);
        parents.splice(index, 1);
        this.markDirty();
    }

    public unlinkParentCustomOutcome(parentCustomOutcome: CustomOutcomeParentCustomOutcomeModel): void {
        const parents = this.projectOutcome.customOutcome!.parentCustomOutcomes!;
        const index = parents.indexOf(parentCustomOutcome);
        parents.splice(index, 1);
        this.markDirty();
    }

    public onLinkageNotesChanged(): void {
        this.markDirty();
    }
}
